import { render, staticRenderFns } from "./QuestionContainer.vue?vue&type=template&id=675a0a3c&"
import script from "./QuestionContainer.vue?vue&type=script&lang=js&"
export * from "./QuestionContainer.vue?vue&type=script&lang=js&"
import style0 from "./QuestionContainer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports